export default __webpack_public_path__ + "static/media/soy_free.957ef8d1.jpeg";